import { Inject, Injectable, Optional, Type } from "@angular/core";
import { MedHostDirective } from "../directives/med-host.directive";
import { MedPopperContent } from "../types";

export const MED_TOOLTIP_COMPONENTS_MAP = "medTooltipComponentsMap";
export const MED_TOOLTIP_SIZES_MAP = "medTooltipSizesMap";
const DEFAULT_MAX_WIDTH = "260px";

@Injectable({
  providedIn: "root",
})
export class MedTooltipService {
  constructor(
    @Inject(MED_TOOLTIP_COMPONENTS_MAP) private componentsMap: Map<string, Type<MedPopperContent<any, any>>>,
    @Optional() @Inject(MED_TOOLTIP_SIZES_MAP) private sizesMap: Map<string, string>,
  ) {}

  host?: MedHostDirective;
  tooltipContentEl!: HTMLElement;
  maxWidth = DEFAULT_MAX_WIDTH;

  show(type: string): void {
    if (this.host === undefined) {
      throw new Error("Unknown modal content host");
    }

    this.host.viewContainerRef.clear();

    const component = this.componentsMap.get(type);
    this.host.viewContainerRef.createComponent<any>(component as any);
    this.maxWidth = this.sizesMap?.get(type) || DEFAULT_MAX_WIDTH;
  }
}
